import { Table } from "react-bootstrap";
import styled, { StyledFunction } from "styled-components"
import { Nav, NavItem } from "react-bootstrap";

interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string,
    fontSize?: string
}

interface INavItemProps {
    minTabWidth?: string
}

export const TableHeaderWrapper = styled.table`
    & > thead > tr > th {
        color: white;
        overflow: hidden;
        padding: 5px 0px 5px 3px !important;
    }
`;

export const TableRowWrapper = styled.tr`
    & > td {
        padding: 3px 0px 3px 3px !important;
        vertical-align: middle !important;
    }
`;

export const SummaryTitles = styled.tr`
    & > td {
        background-color: #00004c;
        color: white;
        font-size: 9px;
    }
`;

export const SummaryValues = styled.tr`
    & > td {
        font-size: 12px;
    }
`;

export const TableWrapper = styled(Table)`
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }
`;

interface IGridWrapperProps {
    height?: string
}

export const GridWrapper = styled.div<IGridWrapperProps>`
    height: ${p => p.height ? p.height : '73vh'};
    
    font-family: Roboto;

    .ag-header {
        background-color: #133366;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row-selected > .ag-cell {
        background-color: yellow !important;
        color: black;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .center-list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 6px;
        color: #fff;
    }

    .center-list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
        font-size: 12px;
        justify-content: center;
        display: flex;
    }

    .customHeaderLabel {
        text-align: center;
    }
`;

export const HeaderWrapper = styled.div`
    .billing-header {
        font-size: 28px;
        font-weight: 500;
        margin-bottom: 20px;
    }
`;

export const NavWrapper = styled(Nav) <INavWrapperProps>`
    display: flex;
    // justify-content: space-between;
    align-items: center;
    width: 100%;
    // margin-bottom: 20px;
    // border: 1px solid red;

    & > .acc-tabs > li {
        height: 48px;
    }

    & > .acc-tabs > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #337ab7;
        color: white;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > .acc-tabs > li.active > a {
        color: #555;
        background-color: #fff;
    }

    & > div > .acc-pills > li > a {
        padding: 5px 7px;
        // font-size: ${(p: INavWrapperProps) => p.fontSize != null ? p.fontSize : '14px'};
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
    }

    & > div > .acc-pills > li > span {
        position: relative;
        display: block;
        font-size: 12px;
        padding: 5px 2px;
        color: #ccc;
        // min-height: 72px;
    }

    & > div > .acc-pills > li > div.pill-divider {
        margin-left: 3px;
        margin-right: 3px;
        margin-top: 9px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
        // border: 0.5px solid #ccc
    }

    & > div > .acc-pills > li > div.pill-divider {
        margin-left: 3px;
        margin-right: 3px;
        margin-top: 9px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
        // border: 0.5px solid #ccc
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            font-size: 12px;
            min-width: 120px;
        }
    }
`;


export const NavItemWrapper = styled(NavItem) <INavItemProps>`

    & > a {
        // border-radius: 8px !important;
        // text-align: center;
        // border: 1px solid #337ab7;
        // min-height: 72px;
    }

    & > a > span.badge {
        font-size: 10px;
    }

    & > a > span.type-count {
        font-size: 12px;
    }
`;
